import { ChatTabType } from '@features/chat/types/types';
import { mdiAccountGroupOutline, mdiForumOutline, mdiHandshakeOutline } from '@mdi/js';

export const tabNavigationTabs = [
	{ label: ChatTabType.Direct, icon: mdiForumOutline, translationKey: 'chats.chatsTitle' },
	{
		label: ChatTabType.Groups,
		icon: mdiAccountGroupOutline,
		translationKey: 'chats.groupsTitle',
	},
	{
		label: ChatTabType.Completed,
		icon: mdiHandshakeOutline,
		translationKey: 'chats.completedTitle',
	},
	// { label: ActiveTabTypes.Calls, icon: mdiPhoneOutline, translationKey: 'chats.callsTitle' },
];
